import script from "./addPrestaView.vue?vue&type=script&setup=true&lang=ts"
export * from "./addPrestaView.vue?vue&type=script&setup=true&lang=ts"

import "./addPrestaView.vue?vue&type=style&index=0&id=58a430f2&lang=scss&scoped=true"
import "./addPrestaView.vue?vue&type=style&index=1&id=58a430f2&lang=scss"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a430f2"]])

export default __exports__